// extracted by mini-css-extract-plugin
export var homepageSection = "homePage-module--homepageSection--dp4tl";
export var listItem = "homePage-module--listItem--hnGwi";
export var newsContainer = "homePage-module--newsContainer--+QCWn";
export var newsContent = "homePage-module--newsContent--HDZ0r";
export var newsDate = "homePage-module--newsDate--S2X8j";
export var newsDescription = "homePage-module--newsDescription--0dbRF";
export var newsItem = "homePage-module--newsItem--UYvDa";
export var newsTitle = "homePage-module--newsTitle--6pjZn";
export var universityCard = "homePage-module--universityCard--mpKfr";
export var universityDegree = "homePage-module--universityDegree--4Ldnf";
export var universityImage = "homePage-module--universityImage--iLTpo";
export var universityInfo = "homePage-module--universityInfo--MMKap";
export var universityLogo = "homePage-module--universityLogo--qE-PY";
export var universityName = "homePage-module--universityName--n93Y-";
export var universityPeriod = "homePage-module--universityPeriod--1otvr";